module.exports = "/_next/static/images/c6bf9797b01d96899629cddc3967427a-slide-2-large.png";